(function () {
    if (window.productCardSliderLoaded) return;
    window.productCardSliderLoaded = true;

    var SWIPE_THRESHOLD = 40;
    var TAP_TOLERANCE = 8;

    function isRtl() {
        return document.body.classList.contains('layout_rtl');
    }

    class ProductCardSlider extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            if (this._initialized) return;
            this._initialized = true;

            this.track = this.querySelector('.pcs-track');
            this.slides = this.querySelectorAll('.pcs-slide');
            this.dots = this.querySelectorAll('.pcs-dot');
            this.prevBtn = this.querySelector('.pcs-arrow--prev');
            this.nextBtn = this.querySelector('.pcs-arrow--next');
            this.current = parseInt(this.getAttribute('data-current') || '0', 10) || 0;
            this.total = this.slides.length;

            if (!this.track || this.total <= 1) return;

            const self = this;

            if (this.prevBtn) {
                this.prevBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    self.go(self.current - 1);
                });
            }
            if (this.nextBtn) {
                this.nextBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    self.go(self.current + 1);
                });
            }
            this.dots.forEach(function (dot, i) {
                dot.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    self.go(i);
                });
            });

            this.bindSwipe();
            this.update();
        }

        bindSwipe() {
            const cardMedia = this.closest('.card-media');
            if (!cardMedia) return;
            const link = cardMedia.querySelector('.card-link');
            const target = link || cardMedia;
            const self = this;
            let startX = 0, startY = 0, dx = 0, dy = 0, swiping = false, active = false;

            const onStart = function (e) {
                const t = e.touches ? e.touches[0] : e;
                startX = t.clientX;
                startY = t.clientY;
                dx = 0;
                dy = 0;
                swiping = false;
                active = true;
            };
            const onMove = function (e) {
                if (!active) return;
                const t = e.touches ? e.touches[0] : e;
                dx = t.clientX - startX;
                dy = t.clientY - startY;
                if (!swiping && Math.abs(dx) > TAP_TOLERANCE && Math.abs(dx) > Math.abs(dy)) {
                    swiping = true;
                }
            };
            const onEnd = function () {
                if (!active) return;
                active = false;
                if (swiping && Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
                    const dir = isRtl() ? -1 : 1;
                    if (dx * dir < 0) {
                        self.go(self.current + 1);
                    } else {
                        self.go(self.current - 1);
                    }
                    if (link) {
                        const preventOnce = function (ev) {
                            ev.preventDefault();
                            ev.stopPropagation();
                            link.removeEventListener('click', preventOnce, true);
                        };
                        link.addEventListener('click', preventOnce, true);
                        setTimeout(function () {
                            link.removeEventListener('click', preventOnce, true);
                        }, 400);
                    }
                }
            };

            target.addEventListener('touchstart', onStart, { passive: true });
            target.addEventListener('touchmove', onMove, { passive: true });
            target.addEventListener('touchend', onEnd);
            target.addEventListener('touchcancel', onEnd);

            // Mouse drag (desktop)
            const onMouseDown = function (e) {
                if (e.button !== 0) return;
                onStart(e);
                document.addEventListener('mousemove', onMouseMove);
                document.addEventListener('mouseup', onMouseUp);
            };
            const onMouseMove = function (e) {
                if (!active) return;
                onMove(e);
                if (swiping) e.preventDefault();
            };
            const onMouseUp = function (e) {
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', onMouseUp);
                onEnd();
            };
            target.addEventListener('mousedown', onMouseDown);
            target.addEventListener('dragstart', function (e) { e.preventDefault(); });
        }

        go(idx) {
            if (idx < 0) idx = 0;
            if (idx > this.total - 1) idx = this.total - 1;
            if (idx === this.current) return;
            this.current = idx;
            this.setAttribute('data-current', String(idx));
            this.loadSlide(idx);
            this.update();
        }

        // Slides after the first are left unloaded by lazy-loading.js (collection
        // grid) or kept `lazyload-deferred` (search carousel)
        loadSlide(idx) {
            const slide = this.slides[idx];
            const deferred = slide && slide.querySelector('img.lazyload-deferred');
            if (deferred) {
                if (window.unveilDeferredImage) window.unveilDeferredImage(deferred);
                return;
            }
            const img = slide && slide.querySelector('img[data-src]');
            if (!img || img.classList.contains('loaded') || img._pcsLoading) return;
            img._pcsLoading = true;
            if (window.plpLazy) {
                window.plpLazy.loadImage(img);
                return;
            }
            if (img.dataset.srcset) img.srcset = img.dataset.srcset;
            img.src = img.dataset.src;
            img.classList.add('loaded');
        }

        update() {
            const dir = isRtl() ? 1 : -1;
            const offset = dir * this.current * 100;
            this.track.style.transform = 'translateX(' + offset + '%)';
            const cur = this.current;
            this.dots.forEach(function (d, i) {
                d.classList.toggle('is-active', i === cur);
            });
            this.slides.forEach(function (s, i) {
                s.classList.toggle('is-active', i === cur);
            });
            if (this.prevBtn) this.prevBtn.classList.toggle('is-disabled', this.current === 0);
            if (this.nextBtn) this.nextBtn.classList.toggle('is-disabled', this.current === this.total - 1);
        }
    }

    if (typeof customElements !== 'undefined' && !customElements.get('product-card-slider')) {
        customElements.define('product-card-slider', ProductCardSlider);
    }
})();
